import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";
import { Hero } from "@/sections/Hero";
import { Marquee } from "@/sections/Marquee";
import { Demo } from "@/sections/Demo";
import { HowItWorks } from "@/sections/HowItWorks";
import { Benefits } from "@/sections/Benefits";
import { UseCases } from "@/sections/UseCases";
import { Purchase } from "@/sections/Purchase";
import { Specs } from "@/sections/Specs";
import { Faq } from "@/sections/Faq";
import { FinalCTA } from "@/sections/FinalCTA";

export default function Landing() {
  return (
    <div className="min-h-screen bg-sand" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Demo />
        <HowItWorks />
        <Benefits />
        <UseCases />
        <Purchase />
        <Specs />
        <Faq />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
